var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{key:_vm.doc.public_id,attrs:{"href":_vm.doc.secure_url,"variant":"dark","target":"_blank","pill":""}},[_c('font-awesome-icon',{attrs:{"icon":"paperclip"}}),_vm._v("\n  "+_vm._s(_vm.doc.original_filename)+"."+_vm._s(_vm.doc.format)+" ("+_vm._s(_vm.formatBytes(_vm.doc.bytes))+")\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }